<template>
  <div>
    <span id="address">您现在所在的位置:</span>
    <el-breadcrumb v-if="msg != '科室导览'" separator-class="el-icon-arrow-right" :class=" msg == '专家介绍' ? 'yes' : 'no' ">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="msg != ''">{{msg}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-breadcrumb v-if="msg == '科室导览'" separator-class="el-icon-arrow-right" :class=" msg == '科室导览' ? 'yes' : 'no' ">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="msg != ''">{{msg}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  props: {
    msg: String,
  },
};
</script>
<style lang="less">
.on{
  float: left!important;
}
.yes{
  float: none!important;
  color: black!important;
}
.el-breadcrumb {
  line-height: 2 !important;
  float: left;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  color: white !important;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: white !important;
  font-weight: 600 !important;
}
.el-breadcrumb__separator{
    color: #ffffff!important;
}
</style>
<style lang="less" scoped>

#address {
  float: left;
  line-height: 1.8;
  margin-right: 20px;
  color: #ffffff;
}
</style>